// export this package's api
// base 2.9.3
import Vue from 'vue';
import TreeSelect from './src';
import ref from 'vue-ref';

Vue.use(ref, { name: 'ant-ref' });
export default TreeSelect;

export { TreeNode, SHOW_ALL, SHOW_PARENT, SHOW_CHILD } from './src';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.2@ant-design-vue/es/vc-tree-select/index.js
// module id = null
// module chunks = 